import { Input } from '@/app/common/components/input/Input'
import Label from '@/app/common/components/Label'
import React from 'react'

// Format phone number to US standard: (123) 456-7890
const formatPhoneNumber = (value = '') => {
  // Strip all non-digit characters
  const phoneNumber = value.replace(/\D/g, '')

  // Apply US formatting
  let formatted = ''
  if (phoneNumber.length === 0) {
    formatted = ''
  } else if (phoneNumber.length <= 3) {
    formatted = `(${phoneNumber}`
  } else if (phoneNumber.length <= 6) {
    formatted = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  } else {
    formatted = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
  }

  return formatted
}

type Props = {
  onChange: (value: string) => void
  onBlur: () => void
  value: string | undefined
  label?: string | React.ReactNode
}

const FormattedPhoneInput = (props: Props) => {
  const { onChange, onBlur, value, label = 'Phone Number (Optional)' } = props

  return (
    <div className="">
      <Label htmlFor="phone">{label}</Label>
      <Input
        id="phone"
        type="tel"
        className="shadow-none mt-0"
        placeholder="(123) 456-7890"
        value={formatPhoneNumber(value)}
        onChange={(e) => {
          // Get raw value without formatting
          const rawValue = e.target.value.replace(/\D/g, '')
          // Limit to 10 digits (US phone number length)
          const limitedValue = rawValue.slice(0, 10)
          onChange(limitedValue)
        }}
        onBlur={onBlur}
      />
    </div>
  )
}

export default FormattedPhoneInput
